import { useState } from 'react';
import { CountryCode } from 'i18n/types';
import { ContactFormData } from 'components/ContactInfoForm';
import { useMerchant } from 'hooks/context/merchant';
import { createHookContext } from '@clover-util/react-context';
import { useSessionStorageState } from '@clover-util/use-storage-state';

export type OrderDetailsState = ReturnType<typeof useOrderDetails>;

export const COLO_CONTACT_INFO = 'colo-contact-info';
export const COLO_CONTACT_NOTE = 'colo-contact-note';

export const { OrderDetailsProvider, useOrderDetails } = createHookContext('OrderDetails', () => {
  const { country } = useMerchant();

  const [tipValue, setTipValue] = useState(0);

  const [contactFormData, setContactFormData] = useSessionStorageState<ContactFormData>(COLO_CONTACT_INFO, {
    customer: {
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      country: country as CountryCode,
    }
  });

  const [noteFormData, setNoteFormData] = useSessionStorageState<{ note: string }>(COLO_CONTACT_NOTE, {
    note: '',
  });

  return {
    setContactFormData,
    setTipValue,
    tipValue,
    contactFormData,
    noteFormData,
    setNoteFormData
  };
});
